import { render } from "./PartialPaymentSeparator.vue?vue&type=template&id=1e12019a&lang=pug"
import script from "./PartialPaymentSeparator.vue?vue&type=script&lang=js"
export * from "./PartialPaymentSeparator.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__